const sectionRouting = {
	'': function(){
		return new SectionLoader('home');
	},
	'contact-us': function(){
		return new SectionLoader('contacts');
	},
	'about-us': function(){
		return new SectionLoader('about');
	},
	'how-to-play': function(){
		return new SectionLoader('how-to');
	},
	'faq': true,
	'terms': true,
	'privacy-policy': true,
	'cookies-policy': true,
	'sign-in': true,
	'sign-up': true,
	'verify-email': true,
	'profile': true,
	'errors': true,
	'forgot-password': true,
	'user-content': true,
	'pricing': true,
	'quiz': false,
	'event': true,
	'gift-card': true,
	'events': true,
	'corporate': false,
	'unsubscribe': true,
	'davanaman': false,
	'download': true,
	'for-cities': false,
	'teambuilding': false,
	'get-app': 'self',
	'testimonials': true,
	'blog': true,
	'for-partners': '/become-a-partner',
	'become-a-partner': function () {
		return new SectionLoader('for-partners');
	},
	'create': false,
	'corporate-offer': false,
	'case-studies': true,
	'business': false,
	'groupie-drive': true,
	'experiences': true,
	'code-share': true,
	'map': true,
	'did': true,
	'results-summary': true,
	'rtu': true,
	'goodies': true,
};